import { Box, Typography } from "@mui/material";
import PrimaryButton from "@/components/common/PrimaryButton";

type RestaurantErrorScreenProps = {
  message: string | null;
  onRetry: () => void;
};

export default function RestaurantErrorScreen({
  message,
  onRetry,
}: RestaurantErrorScreenProps) {
  return (
    <Box
      className="flexCenter flexColumn"
      sx={{
        minHeight: "100vh",
        px: 3,
        gap: 2,
        textAlign: "center",
      }}
    >
      <Typography variant="h5" component="h1">
        Unable to load restaurant configuration
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {message ?? "Please check your connection and try again."}
      </Typography>
      <PrimaryButton onClick={onRetry} size="large">
        Retry
      </PrimaryButton>
    </Box>
  );
}
